import { IconButton } from "@carbon6/c6-frontend-design";

// 경고 종류별 이름과 툴팁이다. 목록 열·카드·상세 제목이 이 문구를 같이 쓴다.
const EPISODE_WARNING_TEXT = {
  // 집계 단위는 후보 구간이 아니라 제외되지 않은 에피소드 수다.
  qualityCandidate: { label: "미처리 후보", title: "미처리 품질 후보가 있는 에피소드 보기" },
  // 업로드는 이 에피소드를 제외해 둔다. 리뷰에서 복원했으면 제외가 아니라 학습을 막는다. 그래서
  // 툴팁은 "제외" 라고 단정하지 않는다.
  missingChannel: { label: "채널 누락", title: "채널 파일이 빠진 에피소드 보기" },
} as const;

type DatasetEpisodeWarningBadgeProps = {
  kind: keyof typeof EPISODE_WARNING_TEXT;
  count: number | undefined;
  onOpen: () => void;
};

/**
 * 주의가 필요한 에피소드 수를 경고 톤 버튼으로 표시한다. 누르면 그 에피소드를 연다.
 *
 * 수가 없거나 0 이면 그리지 않는다. "없음" 같은 문구는 호출부가 정한다. 클릭은 행·카드로 번지지
 * 않는다. 행이나 카드를 누르면 다른 화면으로 이동하기 때문이다.
 */
export function DatasetEpisodeWarningBadge({
  kind,
  count,
  onOpen,
}: DatasetEpisodeWarningBadgeProps) {
  if (count === undefined || count === 0) return null;
  const { label, title } = EPISODE_WARNING_TEXT[kind];
  return (
    <IconButton
      text={`${label} · 에피소드 ${count.toLocaleString()}개`}
      size="sm"
      variant="surface"
      tone="warning"
      title={title}
      onClick={(event) => {
        event.stopPropagation();
        onOpen();
      }}
    />
  );
}
